var map = {
	"./#03CEA4/Time.svg": "68d4",
	"./#3777FF/Time.svg": "c696",
	"./#EE964B/Time.svg": "11ab",
	"./#F754A2/Time.svg": "d7a9",
	"./#FF495C/Time.svg": "5175"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b0e7";